module.exports = __webpack_public_path__ + "static/img/no-module.8cc5ea9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/no-module.png
// module id = Mutl
// module chunks = 1